import { FunctionComponent, useEffect, useRef, useState } from 'react';
import { GiftCardBalanceDialog } from 'components/header/GiftCardBalanceDialog';
import { getGiftCardBalance } from 'selectors/patronSelectors';
import { sessionPrioritizedBackend } from 'utils/storage-backends/backends';
import { useMediaQuery } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useTheme } from '@material-ui/core/styles';

const balanceCheckedSessionKey = 'tock_gc_balance_checked';

export const GIFT_CARD_THRESHOLD_AMOUNT = 100 * 10;

export const GiftCardBalanceDialogContainer: FunctionComponent<{}> = () => {
  const giftCardBalance = useSelector(getGiftCardBalance);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const theme = useTheme();
  const matchesxs = useMediaQuery(theme.breakpoints.down('xs'));

  const hasChecked = useRef<boolean>(
    BROWSER
      ? sessionPrioritizedBackend.get(balanceCheckedSessionKey)
        ? JSON.parse(sessionPrioritizedBackend.get(balanceCheckedSessionKey)).balanceCheckedSession
        : false
      : false
  );

  useEffect(() => {
    const shouldShowBalance =
      (giftCardBalance.data?.balanceCents ?? 0) > GIFT_CARD_THRESHOLD_AMOUNT;

    if (giftCardBalance.isInitialized) {
      if (shouldShowBalance && matchesxs && !hasChecked.current) {
        setIsOpen(true);
      }
      hasChecked.current = true;
      sessionPrioritizedBackend.set(
        balanceCheckedSessionKey,
        JSON.stringify({ balanceCheckedSession: true })
      );
    }
  }, [matchesxs, giftCardBalance]);

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <GiftCardBalanceDialog
      onClose={handleClose}
      balanceCents={giftCardBalance.data?.balanceCents ?? 0}
      isOpen={isOpen}
    />
  );
};
